import PropTypes from "prop-types";
import ColumnModel from "../../../../models/datasource/column";
import {
    filterValueSelectEvent,
    inputSubmitEvent
} from '../../../../services/query_builder_events';
import AttributeMenu from './attribute_menu';


export default class FilterValuesSelector extends AttributeMenu {
    componentDidMount() {
        super.componentDidMount();
        this.unbindInputSubmitEventListener = inputSubmitEvent.listen((value) => {
            filterValueSelectEvent.emit(value);
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.unbindInputSubmitEventListener();
    }

    renderMenu() {
        return null;
        // const {column, styles, variables} = this.props;
        // return (
        //     <ul className="filter-list w-list-unstyled" style={styles}>
        //         <div className="label filter-group-heading">Variables</div>
        //         {variables.map(value => (
        //             <li key={value} className="filter-item" onClick={() => { filterValueSelectEvent.emit(value); }}>
        //                 <strong>{`{${value}}`}</strong>
        //             </li>
        //         ))}
        //
        //         <div className="label filter-group-heading">Pattern Match</div>
        //         {column.sample.map((value, i) => (
        //             <li key={i} className="filter-item" onClick={() => { filterValueSelectEvent.emit(value); }}>
        //                 <strong>{value}</strong>
        //             </li>
        //         ))}
        //
        //     </ul>
        // );
    }
}

FilterValuesSelector.propTypes = {
    column: PropTypes.instanceOf(ColumnModel).isRequired,
    styles: PropTypes.object,
    variables: PropTypes.array,
};

FilterValuesSelector.defaultProps = {
    styles: {},
    variables: ['INDUSTRY', 'STATE'],  // just for testing so far
};
